// app/javascript/controllers/user_search_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "dropdown"]

  connect() {
    this.searchTimeout = null
    this.boundClickOutside = this.clickOutside.bind(this)
    document.addEventListener('click', this.boundClickOutside)
  }

  disconnect() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
    document.removeEventListener('click', this.boundClickOutside)
  }

  search() {
    const query = this.inputTarget.value.trim()

    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }

    if (query.length < 2) {
      this.hideResults()
      return
    }

    // Debounce search by 300ms
    this.searchTimeout = setTimeout(async () => {
      try {
        const response = await fetch(`/search_accounts/search?q=${encodeURIComponent(query)}`)
        const users = await response.json()
        this.showResults(users)
      } catch (error) {
        console.error('Search failed:', error)
        this.hideResults()
      }
    }, 300)
  }

  showResults(users) {
    if (!this.hasResultsTarget) return

    if (users.length === 0) {
      this.resultsTarget.innerHTML = '<a class="dropdown-item">No users found</a>'
    } else {
      this.resultsTarget.innerHTML = users.map(user => `
        <a href="#" class="dropdown-item" data-action="click->user-search#selectUser" data-user-id="${user.id}" data-user-name="${user.name}">
          <div class="media">
            <div class="media-left">
              <figure class="image is-24x24">
                ${user.avatar_url ?
                  `<img src="${user.avatar_url}" alt="${user.name}" class="is-rounded">` :
                  `<div class="has-background-grey-light is-flex is-align-items-center is-justify-content-center" style="width: 24px; height: 24px; border-radius: 50%; font-size: 12px; color: white;">${user.name.charAt(0).toUpperCase()}</div>`
                }
              </figure>
            </div>
            <div class="media-content">
              <div class="title is-7">${user.name}</div>
              <div class="subtitle is-7 has-text-grey">${user.discoveries_count} discoveries</div>
            </div>
          </div>
        </a>
      `).join('')
    }

    // Show the dropdown menu
    this.resultsTarget.classList.remove('is-hidden')
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.add('is-active')
    }
  }

  hideResults() {
    // Hide the dropdown menu
    if (this.hasResultsTarget) {
      this.resultsTarget.classList.add('is-hidden')
    }
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.remove('is-active')
    }
  }

  selectUser(event) {
    event.preventDefault()
    const userId = event.currentTarget.dataset.userId
    const userName = event.currentTarget.dataset.userName

    // Update input with selected user name
    this.inputTarget.value = userName
    this.hideResults()

    // Navigate to discoveries with user filter
    this.goToUserDiscoveries(userId)
  }

  goToUserDiscoveries(userId = null) {
    const targetUserId = userId || this.getUserIdFromInput()

    if (!targetUserId) return

    const url = new URL(window.location)
    // url.pathname = '/discoveries/index_feed'
    url.searchParams.set('content_filter', this.getCurrentContentFilter())
    url.searchParams.set('source_filter', 'user')
    url.searchParams.set('user_id', targetUserId)

    window.location.href = url.toString()
  }

  getCurrentContentFilter() {
    // Try to get from current URL or default to 'latest'
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('content_filter') || 'latest'
  }

  getUserIdFromInput() {
    // This would need to be implemented if we want to support typing and pressing enter
    // For now, we'll rely on the dropdown selection
    return null
  }

  // Handle clicks outside to close dropdown
  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }
}